async function getProfile(profileID) {
    const authService = require("./auth");
    //headers
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${await authService.authFront()}`);

    //Body

    var requestOptions = {
        method: 'GET',
        headers: headers
    };

    const req = await fetch(`${process.env.API_URL}/donors/profile/${profileID}`.toLowerCase(), requestOptions)

    return req.json();

}

async function getProfileBackend(profileID) {
    const authService = require("./auth");
    const request = require("request-promise");

    var options = {
        'method': 'GET',
        'url': `${process.env.API_URL}/donors/profile/${profileID}`,
        'headers': {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${await authService.authBack()}`
        }

    };

    try {
        var result = await request(options).promise()
        return JSON.parse(result)
    } catch (err) {
        throw err
    }

}

async function getDonorsList(term) {
    const authService = require("./auth");
    //headers
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${await authService.authFront()}`);

    //Body

    var requestOptions = {
        method: 'GET',
        headers: headers
    };

    let querystring = '';

    if (term && term != null && term != '') querystring += `?term=${term}`;

    const req = await fetch(`${process.env.API_URL}/donors/list${querystring}`, requestOptions)

    return req.json();
}

const list = async (page) => {
    const request = require("request-promise");
    const authService = require("./auth");
    var options = {
        'method': 'GET',
        'url': `${process.env.API_URL}/donors/list?page=${page}&profiles=true`,
        'headers': {
            'Authorization': `Bearer ${await authService.authBack()}`
        }
    };
    try {
        const result = await request(options)
        return result;
    } catch (err) {
        console.log('err',err)
        throw err;
    }
}

module.exports = {
    getProfile: getProfile,
    getProfileBackend: getProfileBackend,
    getDonorsList: getDonorsList,
    list: list
}
